export class IndirectUploadZoneConfig {
  public url: string;
  public fileType: string;
  public relatedTo?: string;
  public aspectRatio?: string;
  public onFileUploaded: (fileEntity: any, formControlName: string, presignApiResponse: any, file?: Blob) => {};
}
